import { AES, enc, mode } from "crypto-js";

import { EnvironmentConfig } from "../config/environment.config";

export module CryptoHelper {
  const _key = enc.Base64.parse(EnvironmentConfig.cryptoToken);
  const _cfg = { iv: enc.Base64.parse(EnvironmentConfig.cryptoIv), mode: mode.CBC };

  export const encrypt = (data: string) => {
    return AES.encrypt(data, _key, _cfg).toString();
  };
  export const decrypt = (data: string) => {
    return AES.decrypt(data, _key, _cfg).toString(enc.Utf8);
  };
  export const decryptArray = (data: string) => {
    try {
      return JSON.parse(decrypt(data));
    } catch (error) {
      localStorage.clear();
      window.location.href = "/login";
    }
  };
  export const getSHA256Hash = async (input: string) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray.map((item) => item.toString(16).padStart(2, "0")).join("");
    return hash;
  };
}
